export default __webpack_public_path__ + "static/plx-tl-09fe7031550e9f07293c6a9af3f1c75f.jpg";